import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["href"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", {
  "aria-hidden": "true",
  class: "icon icon-info-sign"
}, null, -1)
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "uploaded-file" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", {
  "aria-hidden": "true",
  class: "icon icon-delete"
}, null, -1)
const _hoisted_6 = { class: "screen-reader-text" }
const _hoisted_7 = { class: "small" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { for: "measurements-selector-file-upload" }
const _hoisted_10 = ["name", "accept"]
const _hoisted_11 = {
  key: 0,
  class: "small"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = ["href"]
const _hoisted_14 = { key: 1 }
const _hoisted_15 = {
  key: 3,
  class: "upload-container__info-button"
}
const _hoisted_16 = { class: "dxf-help-content" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", {
  "aria-hidden": "true",
  class: "icon icon-info-sign"
}, null, -1)
const _hoisted_18 = { class: "dxf-help-text" }
const _hoisted_19 = { class: "dxf-help-title" }

import { FILE_INPUT_NAME } from "@/utilities/Client";
import ValidationMessage from "@/components/UI/ValidationMessage.vue";
import InstructionsButton from "@/components/UI/InfoModal/InstructionsButton.vue";
import InfoModal from "@/components/UI/InfoModal/InfoModal.vue";
import { computed, ref } from "vue";
import { useStore } from "vuex";

interface Props {
	isInPreview?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ShapeUpload',
  props: {
    isInPreview: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props;

const store = useStore();
const measurementSelectorVariables = computed(() => window.measurementSelectorVariables);
const { measurementsConfig, drawingRules, drawingExplainer, i18n } = measurementSelectorVariables.value;
const showDrawingRules = !!drawingRules;
const showDrawingExplanation = !!drawingExplainer;

const isHoveringFile = ref(false);
const fileUpload = ref(null);
const filename = computed(() => store.getters.getOriginalFilename);
const fileInputName = ref(FILE_INPUT_NAME);
const isUploading = computed(() => store.getters.getIsParsingFile);
const hasSucceeded = computed(() => store.getters.uploadedContent !== "");
const hasProblematicCorners = computed(() => store.getters.hasProblematicCorners);
const extendedProductInformation = computed(() => (window as any).extendedProductInformation || {});
const dxfUploadInfo = computed(() => extendedProductInformation.value.dxf_upload || []);
const showDxfInfo = computed(() => dxfUploadInfo.value && dxfUploadInfo.value.length > 0);

const allowed_mime_types = [
	'application/dxf',
	'application/x-autocad',
	'application/x-dxf',
	'drawing/x-dxf',
	'image/vnd.dxf',
	'image/x-autocad',
	'image/x-dxf',
	'zz-application/zz-winassoc-dxf',
];
const allowed_file_extensions = [
	'.dxf',
];

if ( measurementsConfig && measurementsConfig['base'] && measurementsConfig['base'].shape === "dxf") {
	filename.value = measurementsConfig['base'].dxfDefinition.original_filename;
}

function hasAllowedMimeType ( mimetype: string ): boolean {

	// dxf tend to miss mimetype, so we allow empty mimetype
	if ( mimetype.length === 0 ) {
		return true;
	}

	if ( allowed_mime_types.includes( mimetype ) ) {
		return true;
	}
	return false;
}

function handleFileUpload(): void {
	const files = fileUpload.value.files;

	if (files.length < 1) {
		return;
	}

	const file = files[0];

	if (!hasAllowedMimeType(file.type)) {
		return;
	}

	uploadFile(file);
}

function resetInput(): void {
	fileUpload.value.value = "";
}

function reset(): void {
	resetInput();

	store.commit('updateDxfDefinition', { svgPath: '' } );
	store.commit('setUploadedContent', {result: '', filename: ''} );
}

function setIsHoveringFile(value: boolean): void {
	isHoveringFile.value = value;
}

function processDroppedFile(event: DragEvent): void {

	// Put it in the input and use the same code path for both upload methods (drag, select file).
	fileUpload.value.files = event.dataTransfer.files;

	handleFileUpload();
}

const uploadFile = async (file: File): Promise<void> => {
	store.dispatch("updateUploadedContent", file);
};

function openModal(): void {
	store.commit('updateCurrentModalName', 'dxfUploadInfo');
}

return (_ctx: any,_cache: any) => {
  const _component_portal_target = _resolveComponent("portal-target")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['upload-container', { 'upload-container--preview': props.isInPreview }])
  }, [
    (showDrawingRules && !props.isInPreview && !showDxfInfo.value)
      ? (_openBlock(), _createElementBlock("a", {
          key: 0,
          href: _unref(drawingRules).url,
          target: "_blank",
          class: "text-link"
        }, [
          _hoisted_2,
          _createTextVNode(" " + _toDisplayString(_unref(drawingRules).title), 1)
        ], 8, _hoisted_1))
      : _createCommentVNode("", true),
    (hasSucceeded.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", null, _toDisplayString(_ctx.$i18n.file), 1),
            _createElementVNode("strong", null, _toDisplayString(filename.value), 1),
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (reset()), ["prevent"]))
            }, [
              _hoisted_5,
              _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$i18n.removeFile.replace("%s", filename.value)), 1)
            ])
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_portal_target, { name: "shape-preview" })
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass({
				'file-dropbox': true,
				'file-dropbox--hovering': isHoveringFile.value,
			}),
      onDragover: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (setIsHoveringFile(true)), ["prevent"])),
      onDragenter: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (setIsHoveringFile(true)), ["prevent"])),
      onDragleave: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (setIsHoveringFile(false)), ["prevent"])),
      onDragend: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (setIsHoveringFile(false)), ["prevent"])),
      onDragdrop: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (setIsHoveringFile(false)), ["prevent"])),
      onDrop: _cache[6] || (_cache[6] = _withModifiers(($event: any) => {
				setIsHoveringFile(false);
				processDroppedFile($event);
			}, ["prevent"]))
    }, [
      _createElementVNode("p", null, [
        _createTextVNode(_toDisplayString(hasSucceeded.value ? _ctx.$i18n.messages.dragNewFilesToUpload : _ctx.$i18n.messages.dragFilesToUpload) + " ", 1),
        _createElementVNode("span", _hoisted_7, "(" + _toDisplayString(allowed_file_extensions.join('/')) + ")", 1),
        (!props.isInPreview)
          ? (_openBlock(), _createElementBlock("br", _hoisted_8))
          : _createCommentVNode("", true),
        _createElementVNode("span", null, _toDisplayString((props.isInPreview ? ' ' : '') + _ctx.$i18n.or), 1)
      ]),
      _createElementVNode("label", _hoisted_9, [
        _createElementVNode("span", {
          class: _normalizeClass(props.isInPreview ? 'text-link-button' : 'button button--blue')
        }, _toDisplayString(_ctx.$i18n.selectFile), 3)
      ]),
      _createElementVNode("input", {
        class: "file-upload",
        id: "measurements-selector-file-upload",
        ref_key: "fileUpload",
        ref: fileUpload,
        name: fileInputName.value,
        type: "file",
        accept: `${allowed_file_extensions.join(',')},${allowed_mime_types.join(',')}`,
        onChange: handleFileUpload,
        "aria-describedby": "measurements-selector-file-upload-validation-message"
      }, null, 40, _hoisted_10),
      (showDrawingExplanation && !props.isInPreview && !showDxfInfo.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createTextVNode(_toDisplayString(_ctx.$i18n.dxfExplainer), 1),
            _hoisted_12,
            _createElementVNode("a", {
              href: _unref(drawingExplainer).url,
              target: "_blank"
            }, _toDisplayString(_unref(drawingExplainer).title), 9, _hoisted_13)
          ]))
        : _createCommentVNode("", true),
      (isUploading.value)
        ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_ctx.$i18n.uploadingFile), 1))
        : _createCommentVNode("", true)
    ], 34),
    (hasProblematicCorners.value)
      ? (_openBlock(), _createBlock(ValidationMessage, {
          key: 2,
          type: "notice"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$i18n.problematicCornersNotice), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (showDxfInfo.value && !props.isInPreview)
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.$i18n.needHelp || 'Need help?'), 1),
              _createElementVNode("button", {
                type: "button",
                class: "dxf-help-link",
                onClick: _withModifiers(openModal, ["prevent"])
              }, _toDisplayString(_ctx.$i18n.dxfHelpText || 'Bekijk onze handige hulpmiddelen voor het maken van een dxf bestand.'), 1)
            ])
          ]),
          _createVNode(InfoModal, {
            "modal-name": "dxfUploadInfo",
            content: dxfUploadInfo.value
          }, null, 8, ["content"])
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})